<template>
  <div style="padding-top: 10px; padding-bottom: 10px;">
    <b-carousel
      class="center"
      style="max-width: 720px"
      :interval="4000"
      controls
      indicators
    >
      <b-carousel-slide
        v-for="image in images"
        :key="image.id"
        :caption="image.name"
        :img-alt="image.name"
        :text="image.description"
        :img-src="image.url"
      />
    </b-carousel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CarouselSection',
  props: {
    id: {
      type: Number,
      default: -1
    }
  },
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters([
      'getSectionById'
    ]),
    section () {
      return this.getSectionById(this.id)
    },
    images () {
      return JSON.parse(this.section.content)
    }
  }
}
</script>

<style>
.carousel-caption {
  position: relative;
  left: 0;
  top: 0;
  color: black;
}
</style>
